import React, { useState } from "react";
import {
  Box,
  Switch,
  FormControlLabel,
  Typography,
  TextField,
  MenuItem,
  Button,
  Grid,
  Stack,
  Select,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";

const TimeLogSettings = () => {
  const [stopTimer, setStopTimer] = useState(false);
  const [requireApproval, setRequireApproval] = useState(false);
  const [sendReminders, setSendReminders] = useState(false);
  const [dailyReport, setDailyReport] = useState(false);
  const [reminderTime, setReminderTime] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [date, setDate] = useState(null);
  const [locationValue, setLocationValue] = useState(null);
  const businessLocation = ["App Administrator", "Manager", "Employee"];
  const handleSave = () => {
    console.log({
      stopTimer,
      requireApproval,
      sendReminders,
      dailyReport,
      reminderTime,
      selectedRoles,
    });
  };
  const handleDateChange = (newDate) => {
    setDate(newDate); // Update the date state
  };

  return (
    <Box
      sx={{
        color: "#000",
        bgcolor: "#fff",
        margin: "auto",
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          borderBottom: "1px solid gray",
          padding: "20px",
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
        }}
      >
        Time Log Settings
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <FormControlLabel
            control={
              <Switch
                checked={stopTimer}
                onChange={(e) => setStopTimer(e.target.checked)}
                sx={{
                  margin: "10px 20px",
                  "& .MuiSwitch-switchBase": {
                    color: "gray", // Default color for the knob
                  },
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#1d82f5", // Knob color when checked
                  },
                  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                    backgroundColor: "gray", // Track color when unchecked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1d82f5", // Track color when checked
                  },
                }}
              />
            }
            label="Stop timer automatically after office time"
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <FormControlLabel
            control={
              <Switch
                checked={requireApproval}
                onChange={(e) => setRequireApproval(e.target.checked)}
                sx={{
                  margin: "10px 20px",
                  "& .MuiSwitch-switchBase": {
                    color: "gray", // Default color for the knob
                  },
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#1d82f5", // Knob color when checked
                  },
                  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                    backgroundColor: "gray", // Track color when unchecked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1d82f5", // Track color when checked
                  },
                }}
              />
            }
            label="Timelog will require approval"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <FormControlLabel
            control={
              <Switch
                checked={sendReminders}
                onChange={(e) => setSendReminders(e.target.checked)}
                sx={{
                  margin: "10px 20px",
                  "& .MuiSwitch-switchBase": {
                    color: "gray", // Default color for the knob
                  },
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#1d82f5", // Knob color when checked
                  },
                  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                    backgroundColor: "gray", // Track color when unchecked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1d82f5", // Track color when checked
                  },
                }}
              />
            }
            label="Send time tracker reminders"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {sendReminders && (
            <Stack direction="column" sx={{ width: "100%" }}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Time
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["TimePicker"]}
                  onChange={(e) => handleDateChange(e.target.value)}
                  sx={{ marginTop: "-10px" }}
                >
                  <DemoItem>
                    <TimePicker
                      value={date}
                      onChange={handleDateChange}
                      sx={{
                        border: "1px solid black",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          color: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "black",
                        },
                      }}
                    >
                      {(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          // Add any additional TextField props if needed
                        />
                      )}
                    </TimePicker>
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>
            </Stack>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <FormControlLabel
            control={
              <Switch
                checked={dailyReport}
                onChange={(e) => setDailyReport(e.target.checked)}
                sx={{
                  margin: "10px 20px",
                  "& .MuiSwitch-switchBase": {
                    color: "gray", // Default color for the knob
                  },
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#1d82f5", // Knob color when checked
                  },
                  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
                    backgroundColor: "gray", // Track color when unchecked
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#1d82f5", // Track color when checked
                  },
                }}
              />
            }
            label="Send Daily Timelog Report"
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          {dailyReport && (
            <Stack direction="column" sx={{ margin: "10px 20px" }}>
              <Typography
                variant="p"
                gutterBottom
                style={{ color: "black", fontSize: "15px" }}
              >
                Choose roles for email report
              </Typography>
              <Select
                value={locationValue}
                autoFocus
                onChange={(e) => setLocationValue(e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{
                  border: "1px solid black",

                  boxSizing: "border-box",
                  "& .MuiOutlinedInput-root": {
                    borderColor: "black !important",
                    "&:hover fieldset": {
                      borderColor: "black !important",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "black !important",
                    },
                  },
                  color: "black",
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <span style={{ color: "gray" }}>Nothing Selected</span>
                    );
                  }
                  return selected;
                }}
              >
                {businessLocation.map((item) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </Stack>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Button
            sx={{
              backgroundColor: "#1d82f5",
              "&:hover": {
                backgroundColor: "orange",
              },
              color: "white",
              margin: "10px 20px 30px 20px",
              height: "35px",
              width: "60px",
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TimeLogSettings;
